import * as React from 'react';
import Svg, { SvgProps, Path, G } from 'react-native-svg';

const FloorIcon = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}>
  <G id='Group'>
    <G id='Group_2'>
      <Path
        id='Vector'
        d='M12 0V4.00001H7.99998V7.99998H4.00001V12H0V16H16V0H12Z'
        fill={props.fill ?? 'white'}
      />
    </G>
  </G>
</Svg>;

export default FloorIcon;
